<template>
  <v-layout wrap class="mx-3">
    <v-flex xs12>
      <v-toolbar flat dense class="toolbarColor">
        <v-toolbar-title class="title">All Experts</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-flex>

    <!-- experts list -->
    <v-flex v-if="experts && experts.length>=1" xs12 sm-12 class="list-section mt-2" v-for="expert in experts" v-bind:key="expert._id">
      <v-layout wrap class="pa-3">
        <v-flex xs12>
          <!-- <img v-if="expert.level==3" src="@/assets/gold.png" style="width: 32px; height: 40px;" alt="" class="right">
          <img v-if="expert.level==2" src="@/assets/silver.png" style="width: 32px; height: 40px;" alt="" class="right">
          <img v-if="expert.level==1" src="@/assets/bronze.png" style="width: 32px; height: 40px;" alt="" class="right"> -->
          <div v-if="(expert.orgJobCount && expert.orgJobCount > 25) && expert.rating >= 4" class="right membership">
            <span class="red--text text--darken-1">Gold</span>
            <img  src="@/assets/gold.png" alt="Gold" >
          </div>
          <div v-else-if="(expert.orgJobCount && expert.orgJobCount > 15) && expert.rating >= 3" class="right membership">
            <span class="red--text text--darken-1">Silver</span>
            <img  src="@/assets/silver.png" alt="Silver" >
          </div>
          <div v-else-if="(expert.orgJobCount && expert.orgJobCount >= 7) && expert.rating >= 2.5" class="right membership">
            <span class="red--text text--darken-1">Bronze</span>
            <img src="@/assets/bronze.png" alt="Bronze" >
          </div>
          <v-chip color="red" dark>{{expert.subscriptions.packageName}}</v-chip>
        </v-flex>
        <v-flex xs12 sm2>
          <v-avatar :size="avatarSize" color="grey lighten-4">
            <img
              v-if="expert.hasProfileImage==false"
              src="@/assets/person.png"
              alt="avatar"
            >
            <img v-else :src="`${host}/uploads/users/${expert.profileImage}`" alt="avatar">
          </v-avatar>
        </v-flex>
        <v-flex xs12 sm6>
          <span>Name: {{expert.firstName}} {{expert.lastName}}</span>
          <br>          
          <span>Phone: <a :href="`tel:${expert.countryCode}${expert.phone}`"><v-icon>phone</v-icon>{{expert.countryCode}}{{expert.phone}}</a></span>
          <br>
          <span>Email: {{expert.email}}</span>
          <h4 v-if="expert.locationOne != null">Location: <span class="font-weight-regular"><a href="javascript:void(0);" @click="showMapModal(expert.locationOne.coordinates[0], expert.locationOne.coordinates[1])" ><v-icon color="primary">room</v-icon>{{expert.locationOne.locationName}}</a></span></h4>
          <br>
          <a v-if="expert.countryCode" :href="`https://wa.me/${expert.countryCode.replace('+','')}${expert.phone}`" target="_blank">
          <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
          </a>
          <a v-else :href="`https://wa.me/${expert.phone.replace('+','')}`" target="_blank">
          <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
          </a><br>
          <v-layout row wrap>
            <v-rating
              v-bind:value="Math.round(expert.rating)"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$vuetify.icons.ratingFull"
              half-increments
              hover
              readonly
            ></v-rating>
            <div v-if="expert.rating" class="red--text text--darken-1 star-margin">({{formatRating(expert.rating)}}/5)</div>
          </v-layout>
          <span><font class="red--text">Assigned Jobs:&nbsp;</font> <b>
            <router-link target="_blank" 
            :to="`/expert/jobs/assigned/${expert._id}`">({{expert.orgJobCount}})</router-link></b></span>
        </v-flex>
        <v-flex xs12 sm4>
          <v-btn flat class="right" color="primary" @click="showRatingModal(expert)">Rate Expert</v-btn>
          <v-btn
            color="green"
            flat
            class="right"
            :to="`/expert/portfolio/${expert._id}`"
          >View Portfolio</v-btn>
        </v-flex>
        <v-flex xs12 sm12></v-flex>
      </v-layout>
    </v-flex>
    <!-- end of list -->

    <v-flex v-if="experts.length<1" sm-12 class="list-section pa-2 my-3 text-xs-center">
      <span style="color: #b71c1c;" >No Experts in the location and/or within the Expertise...</span>
    </v-flex>
    

    <!-- rating modal -->
    <v-dialog v-model="ratingModal" max-width="500px">
      <v-card>
        <v-toolbar color="primary" flat dense dark>
          <v-toolbar-title class="title">Rate Expert</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click="close">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-rating
                v-model="rating"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                half-increments
                hover
              ></v-rating>
            </v-flex>
            <v-flex xs12>
              <v-textarea v-model="review" label="Write a review"></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-btn color="btnColor" small dark @click="saveReview">
                <v-icon>save</v-icon>save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- rating modal -->

    <v-dialog v-model="locdialog" max-width="900px">
      <v-card>
        <v-toolbar color="primary" flat dense dark>
          <v-toolbar-title class="title">Operating Location</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click="closeMapModal">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <!-- <div  id="map-canvas" style="height:300px;width:100%;"></div> -->
                <gmap-map :center="center" 
                :zoom="12" style="width:100%;  height: 400px;">
                  <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :clickable="true"
                      :draggable="true"
                      @click="center=m.position"
                  ></gmap-marker>
                </gmap-map>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <app-snackbar ref="mySnackbar"></app-snackbar>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";  

export default {
  computed: {
    avatarSize() {
      return `80px`;
    },
    ...mapGetters(["host"]),
    ...mapGetters(["user"]),
  },
  props: {
    experts: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      rating: 0.0,
      review: null,
      selectedExpert: {},
      ratingModal: false,
      locdialog: false,
      center: {lat: -1.285355, lng: 36.791082},
      markers: []
    };
  },
  methods: {
    showRatingModal(expert) {
      this.selectedExpert = Object.assign({}, expert);
      this.ratingModal = true;
    },
    saveReview() {
      if(this.rating <= 0) {
        this.$refs.mySnackbar.show("Please give an X/5 Stars Rating", "red");
      } else if (this.review == null) {
        this.$refs.mySnackbar.show("Please fill in review", "red");
      } else {
        const data = {
          rating: this.rating,
          review: this.review,
          expertId: this.selectedExpert._id,
          sonkoId: this.user._id
        };

        const self = this;
        const res = this.$store
          .dispatch("post", { url: "/review/expert", data })
          .then(res => {
            self.rating = 0.0;
            self.ratingModal = false;
            location.reload();
          });
      }
    },
    close() {
      this.ratingModal = false;
    },
    formatRating(rating) {
        return parseFloat(rating.toFixed(1));
    },
    showMapModal(lat, long) {
      this.center = {
        lat: lat,
        lng: long,
      };
      const marker = {
          lat: lat,
          lng: long
        };
      this.markers = [];
      this.markers.push({ position: marker });
      this.locdialog = true;
    },
    closeMapModal() {
      this.locdialog = false;
      this.markers = [];
      this.center = {lat: -1.285355, lng: 36.791082};
    }
  }
};
</script>
<style scoped>
.star-margin {
  margin-top: 8px;
  margin-left: 4px;
}
.membership {
  display: flex;
}
.membership span {
  margin: auto 5px;
}
.membership img {
  width: 32px; 
  height: 40px
}
/*.vue-map-container,
.vue-map-container .vue-map {
    width: 100%;
    height: 100%;
}*/
</style>